module.exports = __webpack_public_path__ + "static/media/cd.cd346cdc.svg";